import { TruncateTooltip } from 'ui/utility/truncate/TruncateTooltip';
import { TipPlacement } from 'ui/tooltip';
import { BasicOption, BasicOptionProps, DoubleLine, SelectValueType } from 'ui/selects';

type TruncatedTooltipBasicOptionProps<TValue extends SelectValueType = string> =
  BasicOptionProps<TValue> & { label?: string; doubleLine?: string };

const STARTING_MAX_WIDTH = 625;

export const TruncatedTooltipBasicOption = <TValue extends SelectValueType = string>({
  label = '',
  doubleLine,
  value,
  ...props
}: TruncatedTooltipBasicOptionProps<TValue>) => {
  const calculatedMaxWidth = STARTING_MAX_WIDTH - (props.Suffix?.toString().length || 0);
  return (
    <BasicOption {...props}>
      <TruncateTooltip
        name={label}
        tooltipProps={{ placement: TipPlacement.Right }}
        textOnly
        maxWidth={calculatedMaxWidth}
      />
      {doubleLine && (
        <DoubleLine data-test="select-double-line" isSelected={props.isSelected}>
          {doubleLine}
        </DoubleLine>
      )}
    </BasicOption>
  );
};
